import { useState } from "react";
import CustomerDetailWalletCurrencyModal from "./CustomerDetailWalletCurrencyModal";
import CustomerDetailWalletSelectModal from "./CustomerDetailWalletSelectModal";
import CustomerDetailWalletTopUpModals from "./CustomerDetailWalletTopUpModals";
import CustomerDetailWalletDebitModal from "./CustomerDetailWalletDebitModal";
import CustomerDetailUploadDocModal from "./CustomerDetailUploadDocModal";
import deActivateAccount from "../../../controllers/user/deactivateAccount";
import activateAccount from "../../../controllers/user/activateAccount";
import CustomerDetailBusinessDetailModal from "./CustomerDetailBusinessDetailModal";
import CustomerDetailSendEmailModal from "./CustomerDetailSendEmailModal";
import { useSelector } from "react-redux";
// import { isUserActionAllowed } from "../../../controllers/settingController";
import useAccount from "../../../hooks/useAccount";

function walletToCurrency(wallet) {
  if (!wallet) return null;
  const code = wallet?.currency || wallet?.currencyCode || "NGN";
  return {
    ...wallet,
    code,
    name: wallet?.name || code,
    symbol: wallet?.symbol || code,
  };
}

function CustomerDetailFooter({ data, callback, wallets = [], onOpenOfficeId }) {
  const { settings } = useSelector((state) => state.settings);
  const [modal, setModal] = useState({
    currency: false,
    debitWallet: false,
    topup: false,
    debit: false,
    upload: false,
    activate: false,
    send: false,
  });
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedDebitCurrency, setSelectedDebitCurrency] = useState(null);
  const [loading, setLoading] = useState({
    upload: false,
    send: false,
    topup: false,
    debit: false,
    disable: false,
    activate: false,
  });
  const { checkPermission } = useAccount();
  const isAccountActive = data?.accountStatus === "Active";

  const handleUserAccountStatus = async () => {
    setLoading({ ...loading, disable: true });
    const res = await (
      isAccountActive
        ? deActivateAccount(data?._id)
        : activateAccount(data?._id)
    ).finally(() => {
      setLoading({ ...loading, disable: false });
    });
    if (res.return) {
      callback(res?.data?.data);
    }
  };

  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency);
    setModal((prev) => ({ ...prev, currency: false, topup: true }));
  };

  const openDebitModal = (wallet) => {
    setSelectedDebitCurrency(walletToCurrency(wallet));
    setModal((prev) => ({
      ...prev,
      debitWallet: false,
      debit: true,
    }));
  };

  const handleDebitClick = () => {
    setSelectedDebitCurrency(null);
    if (wallets.length > 1) {
      setModal((prev) => ({ ...prev, debitWallet: true }));
      return;
    }
    openDebitModal(wallets[0]);
  };

  const handleDebitWalletSelect = (wallet) => {
    openDebitModal(wallet);
  };

  const buttons = [
    {
      label: "Upload Documents",
      type: "primary",
      onClick: () => {
        setModal({ ...modal, upload: true });
      },
      loading: loading.upload,
    },
    {
      label: "Send Email",
      type: "primary",
      onClick: () => {
        setModal({ ...modal, send: true });
      },
      loading: loading.send,
    },
    {
      label: "Top-up Wallet",
      type: "primary",
      onClick: () => {
        setSelectedCurrency(null);
        setModal({ ...modal, currency: true });
      },
      loading: loading.topup,
      disabled: !checkPermission("credit:wallet"),
    },
    {
      label: "Debit Wallet",
      type: "primary",
      onClick: handleDebitClick,
      loading: loading.debit,
      disabled: !checkPermission("debit:wallet"),
    },
    {
      label: "Office ID",
      type: "primary",
      onClick: () => {
        onOpenOfficeId?.();
      },
      disabled: !onOpenOfficeId,
    },
    {
      label: isAccountActive ? "Disable Account" : "Enable Account",
      type: "tertiary",
      onClick: async () => {
        await handleUserAccountStatus();
      },
      loading: loading.disable,
    },
    {
      label: data?.detail?.isVerified
        ? "Deactivate Business"
        : "Activate Business",
      type: data?.detail?.isVerified ? "error" : "secondary",
      onClick: () => {
        setModal({ ...modal, activate: true });
      },
      disabled:
        !data?.detail?.isVerified && !data?.detail?.requestedVerification,
      loading: loading.activate,
    },
  ];

  return (
    <div
      className="w-full flex p-2 lg:p-4 flex-shrink-0 sticky bottom-0 bg-white gap-3 items-center overflow-scroll scroll-hide"
      style={{
        boxShadow:
          "0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.1)",
      }}
    >
      <CustomerDetailWalletCurrencyModal
        open={modal.currency}
        setOpen={(modalState) => setModal({ ...modal, currency: modalState })}
        onSelect={handleCurrencySelect}
      />
      <CustomerDetailWalletSelectModal
        open={modal.debitWallet}
        setOpen={(modalState) =>
          setModal({ ...modal, debitWallet: modalState })
        }
        wallets={wallets}
        onSelect={handleDebitWalletSelect}
      />
      <CustomerDetailWalletTopUpModals
        open={modal.topup}
        setOpen={(modalState) => setModal({ ...modal, topup: modalState })}
        data={data}
        currency={selectedCurrency}
        setLoading={(loadingState) =>
          setLoading({ ...loading, topup: loadingState })
        }
        loading={loading.topup}
        reload={() => callback({ ...data, wallet: (data?.wallet || 0) + 1 })}
      />
      <CustomerDetailWalletDebitModal
        reload={() => callback({ ...data, wallet: (data?.wallet || 0) + 1 })}
        open={modal.debit}
        setOpen={(modalState) => setModal({ ...modal, debit: modalState })}
        data={data}
        currency={selectedDebitCurrency}
        setLoading={(loadingState) =>
          setLoading({ ...loading, debit: loadingState })
        }
        loading={loading.debit}
      />
      <CustomerDetailUploadDocModal
        open={modal.upload}
        setOpen={(modalState) => setModal({ ...modal, upload: modalState })}
        data={data}
        setLoading={(loadingState) =>
          setLoading({ ...loading, upload: loadingState })
        }
        loading={loading.upload}
        callback={callback}
      />
      <CustomerDetailBusinessDetailModal
        open={modal.activate}
        setOpen={(modalState) => setModal({ ...modal, activate: modalState })}
        data={data}
        setLoading={(loadingState) =>
          setLoading({ ...loading, activate: loadingState })
        }
        loading={loading.activate}
        callback={callback}
      />
      <CustomerDetailSendEmailModal
        open={modal.send}
        setOpen={(modalState) => setModal({ ...modal, send: modalState })}
        data={data}
        setLoading={(loadingState) =>
          setLoading({ ...loading, send: loadingState })
        }
        loading={loading.send}
        callback={callback}
      />
      {buttons
        .filter((btn) => !btn.disabled)
        ?.map((btn, btnIndex) => {
          const tertiaryClassname = "bg-black text-white border-black";
          const secondaryClassname = "bg-primary1 text-white border-primary1";
          const primaryClassname =
            "bg-[#F9F9F9] text-[#6D7C94] border-[#E0E0E0]";
          const errorClassname = "bg-[#B81F25] text-white border-[#B81F25]";
          let classname = "";
          switch (btn.type) {
            case "secondary":
              classname = secondaryClassname;
              break;
            case "tertiary":
              classname = tertiaryClassname;
              break;
            case "error":
              classname = errorClassname;
              break;
            default:
              classname = primaryClassname;
              break;
          }
          return (
            <button
              className={`flex flex-1 h-11 px-4 flex-shrink-0 whitespace-nowrap rounded-md border items-center justify-center text-xs lg:text-sm font-semibold text-center ${classname}`}
              key={btnIndex}
              onClick={btn.onClick}
            >
              {btn.loading ? (
                <div
                  className={
                    btn.type === "primary" ? "primaryLoader" : "buttonLoader"
                  }
                ></div>
              ) : (
                btn.label
              )}
            </button>
          );
        })}
    </div>
  );
}

export default CustomerDetailFooter;
